import { render, staticRenderFns } from "./AttestationTotal.vue?vue&type=template&id=2188c651&"
import script from "./AttestationTotal.vue?vue&type=script&lang=js&"
export * from "./AttestationTotal.vue?vue&type=script&lang=js&"
import style0 from "./AttestationTotal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports